/**
 * Storefront Context Redux Slice
 *
 * Mirrors the Storefront's currently resolved shopping country (US, CA, or
 * "other" for international) into Redux, so it can be forwarded to the
 * Gigawatt backend agent via agentState (see useAgentState.ts). The
 * Storefront's own catalog already scopes products to this country
 * (CatalogStore.tsx) — this lets the agent's own product knowledge stay
 * grounded in the same catalog a human would actually see.
 */

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type Country } from '@electricjs/arc';

export const OTHER_SHOPPING_COUNTRY = 'other' as const;

export type ShoppingCountryValue = Country | typeof OTHER_SHOPPING_COUNTRY;

type StorefrontContextState = {
  shoppingCountry: ShoppingCountryValue | undefined;
};

const initialState: StorefrontContextState = {
  shoppingCountry: undefined,
};

const storefrontContextSlice = createSlice({
  name: 'storefrontContext',
  initialState,
  reducers: {
    setShoppingCountry: (
      state,
      action: PayloadAction<ShoppingCountryValue | undefined>
    ) => {
      state.shoppingCountry = action.payload;
    },
  },
});

export const { setShoppingCountry } = storefrontContextSlice.actions;
export default storefrontContextSlice;
